import styled from "styled-components";

export const PageTitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #00032aed;

  span {
    font-size: 10px;
    color: grey;
    display: flex;
    gap: 5px;
  }
`;
